import {TMeta} from '../../machines/appMachine/AppContext';
import {mergeMetadata} from '../../machines/utils/mergeMeta';
import {useCurrentState} from './useCurrentService';

export const useMeta = <T = any>(): T => {
  const state = useCurrentState();
  const meta = mergeMetadata<TMeta>(state.meta);
  return meta as any as T;
};
